import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import INFO from '../../data/user';

const SEOHelmet = ({ 
    title, 
    description, 
    keywords, 
    image, 
    article = false,
    author = "Anna Veretynska",
    publishedTime,
    modifiedTime,
    schema
}) => {
    const location = useLocation();
    const currentUrl = `${INFO.socials.website}${location.pathname}`;
    const fullTitle = title ? `${title} | ${INFO.main.title}` : INFO.main.title;
    const imageUrl = image || `${INFO.socials.website}/homepage.jpg`;
    
    // Generate breadcrumb schema
    const generateBreadcrumbs = () => {
        const pathSegments = location.pathname.split('/').filter(segment => segment);
        const breadcrumbs = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": INFO.socials.website
                }
            ]
        };
        
        let currentPath = "";
        pathSegments.forEach((segment, index) => {
            currentPath += `/${segment}`;
            const name = segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' ');
            breadcrumbs.itemListElement.push({
                "@type": "ListItem",
                "position": index + 2,
                "name": name,
                "item": `${INFO.socials.website}${currentPath}`
            });
        });
        
        return breadcrumbs;
    };
    
    return (
        <Helmet>
            {/* Basic Meta Tags */}
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            {keywords && <meta name="keywords" content={keywords} />}
            <meta name="author" content={author} />
            <link rel="canonical" href={currentUrl} />
            
            {/* Open Graph Tags */}
            <meta property="og:type" content={article ? "article" : "website"} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={currentUrl} />
            <meta property="og:image" content={imageUrl} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:site_name" content={INFO.main.title} />
            <meta property="og:locale" content="en_US" />
            
            {/* Twitter Card Tags */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={imageUrl} />
            <meta name="twitter:site" content="@pasmolab" />
            <meta name="twitter:creator" content="@annaveret_hair" />
            
            {/* Article specific tags */}
            {article && publishedTime && (
                <>
                    <meta property="article:published_time" content={publishedTime} />
                    {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
                    <meta property="article:author" content={author} />
                </>
            )}
            
            {/* Schema.org structured data */}
            <script type="application/ld+json">
                {JSON.stringify(generateBreadcrumbs())}
            </script>
            
            {/* Additional custom schema */}
            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}
        </Helmet>
    );
};

export default SEOHelmet;
